/** Renders desktop Copilot chat panel via portal so z-index is not trapped by layout stacking contexts */
import React from 'react';
import { createPortal } from 'react-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useAISearchPanel, getDesktopChatPanelSx } from '@hooks/useAISearchPanel';
import { CopilotChatbotPanel } from './CopilotChatbotPanel';

export const DesktopChatPanel: React.FC = () => {
  const { isVisible } = useAISearchPanel();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return null;
  }

  return createPortal(
    <Box
      sx={{
        ...getDesktopChatPanelSx(theme),
        display: isVisible ? 'flex' : 'none',
      }}
    >
      <CopilotChatbotPanel />
    </Box>,
    document.body
  );
};
